import {
  EuiGlobalToastList,
  EuiProvider,
  EuiThemeProvider,
} from "@elastic/eui";
import { EuiThemeColorMode } from "@elastic/eui/src/services/theme";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { useAppSelector } from "./app/hooks";
import { setToasts } from "./app/slices/MeetingSlice";
import ThemeSelector from "./components/ThemeSelector";
import CreateMeeting from "./pages/CreateMeeting";
import Dashboard from "./pages/Dashboard";
import JoinMeeting from "./pages/JoinMeeting";
import Login from "./pages/Login";
import EmailLogin from "./pages/EmailLogin";
import SignUpForm from "./pages/SignUpForm";
import Meeting from "./pages/Meeting";
import MyMeetings from "./pages/MyMeetings";
import OneOnOneMeeting from "./pages/OneOnOneMeeting";
import VideoConference from "./pages/VideoConference";
import ConfirmationPage from "./pages/ConfirmationPage";
import ContactPage from "./pages/ContactPage";

import ReportBug from "./pages/ReportBug"
import { Analytics } from "@vercel/analytics/react"
import Wallet from "./pages/Wallet";
import Bug from "./pages/ReportBug";
import PagePreContact from "./pages/PagePreContact";
import UserRecordings from "./pages/UserRecordings";
import UserProfile from "./pages/UserProfile";

export default function App() {
  const dispatch = useDispatch();
  const isDarkTheme = useAppSelector((happymeetApp) => happymeetApp.auth.isDarkTheme);
  const [isInitialEffect, setIsInitialEffect] = useState(true);
  const toasts = useAppSelector((happymeet) => happymeet.meetings.toasts);

  const removeToast = (removedToast: { id: string }) => {
    dispatch(
      setToasts(
        toasts.filter((toast: { id: string }) => toast.id !== removedToast.id)
      )
    );
  };
  const [theme, setTheme] = useState<EuiThemeColorMode>("light");
  useEffect(() => {
    const theme = localStorage.getItem("happymeet-theme");
    if (theme) {
      setTheme(theme as EuiThemeColorMode);
    } else {
      localStorage.setItem("happymeet-theme", "light");
    }
    const script = document.createElement('script');
    script.src = "https://8x8.vc/external_api.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  useEffect(() => {
    if (isInitialEffect) setIsInitialEffect(false);
    else {
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDarkTheme]);

  const overrides = {
    colors: {
      LIGHT: { primary: "#fca803" },
      DARK: { primary: "#fca803" },
    },
  };

  return (
    
    <ThemeSelector>
      <EuiProvider colorMode={theme}>
        <EuiThemeProvider modify={overrides}>

          <Routes>
            <Route path="/userprofile" element={<UserProfile />} />
            <Route path="/login" element={<Login />} />
            <Route path="/confirmationpage" element={<ConfirmationPage />} />
            <Route path="/emaillogin" element={<EmailLogin />} />
            <Route path="/signupform" element={<SignUpForm />} />
            <Route path="/create" element={<CreateMeeting />} />
            <Route path="/create1on1" element={<OneOnOneMeeting />} />
            <Route path="/videoconference" element={<VideoConference />} />
            <Route path="/mymeetings" element={<MyMeetings />} />
            <Route path="/join/:id" element={<JoinMeeting />} />
            <Route path="/meetings" element={<Meeting />} />
            <Route path="/contactteam" element={<ContactPage />} />
            <Route path="/report" element={<ReportBug />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/Bug" element={<Bug />} />
            <Route path="/pageprecontact" element={<PagePreContact />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/recordings" element={<UserRecordings />} />
            <Route path="*" element={<Login />} />

          </Routes>
          <Analytics />
          <EuiGlobalToastList
            toasts={toasts}
            dismissToast={removeToast}
            toastLifeTimeMs={4000}
          />
        </EuiThemeProvider>
      </EuiProvider>
    </ThemeSelector>

  );
}
